import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  COPY_PASTE_THERAPY_PLANNING_LOADING_2_0,
  COPY_PASTE_THERAPY_PLANNING_REQUEST_2_0,
  COPY_PASTE_THERAPY_PLANNING_SUCCESS_2_0,
  COPY_PASTE_THERAPY_PLANNING_FAILURE_2_0,
  COPY_PASTE_THERAPY_PLANNING_RESET_2_0,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isCopyPaste: false,
};

export const copyPasteTherapyPlanningReducer_2_0 = (state = intitialstate, action: any) => {
  switch (action.type) {
    case COPY_PASTE_THERAPY_PLANNING_SUCCESS_2_0: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isCopyPaste: true,
      };
    }

    case COPY_PASTE_THERAPY_PLANNING_FAILURE_2_0:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isCopyPaste: false,
      };
    case COPY_PASTE_THERAPY_PLANNING_LOADING_2_0:
      return {
        ...state,
        loading: true,
      };

    case COPY_PASTE_THERAPY_PLANNING_RESET_2_0:
      return intitialstate;

    default:
      return state;
  }
};
